import {EventBus} from "../../../common/eventBus";
import {resolve} from "../../../container";


export const HERO_TEASER_IMAGE_READY_EVENT = "hero-teaser-image-ready";

export class HeroTeaserImageReadyHandler {

    private hasElementsToObserve: boolean = false;
    private customCallback: () => void = () => {
    };

    public constructor(private imageSelector: string, private eventBus: EventBus = resolve(EventBus)) {
    }

    public hasImageElementsToObserve(): boolean {
        return this.hasElementsToObserve;
    }

    public onImageReady(callback: () => void): this {
        this.customCallback = callback;
        return this;
    }

    public installOn(heroTeaser: HTMLElement): this {
        const imageElements = heroTeaser.querySelectorAll(this.imageSelector);
        for (const imageElement of imageElements) {
            this.hasElementsToObserve = true;
            const imageEl = imageElement.querySelector<HTMLImageElement>("img");
            if (imageEl?.complete) {
                this.triggerFromImageLoaded();
            } else {
                heroTeaser.addEventListener("imageLoaded", () => this.triggerFromImageLoaded());
                heroTeaser.addEventListener("imageOutsideViewPort", () => this.triggerFromInitializedOutsideViewPort());
            }
        }

        return this;
    }

    public manuallyTrigger(): void {
        this.triggerFromImageLoaded();
    }

    private triggerFromImageLoaded(): void {
        this.eventBus.dispatchEvent(HERO_TEASER_IMAGE_READY_EVENT, {});
        this.customCallback();
    }

    private triggerFromInitializedOutsideViewPort(): void {
        this.eventBus.dispatchEvent(HERO_TEASER_IMAGE_READY_EVENT, {});
    }
}